import "./Controls.css";

let Controls = (props) => {
	return (
		<section class={`Controls ${props.modifier}`}>
			{props.children}
		</section>
	)
}

export default Controls;